export class PathConstants {

    public static PATH_EMPTY: string = "";

    public static PATH_SECURITY: string = "security";
    public static PATH_LOGIN: string = "login";
    public static PATH_SECURITY_LOGIN: string = PathConstants.PATH_SECURITY + "/" + PathConstants.PATH_LOGIN;

 
    public static PATH_HOME: string = "web";
    public static PATH_INICIO: string = "inicio";
    public static PATH_ADMIN: string = "administration";
    public static FULLPATH_PAGINA_INICIO: string = PathConstants.PATH_HOME +"/"+PathConstants.PATH_INICIO;


  
    public static PATH_AHORROS: string = "ahorros";
    public static PATH_AHORROS_SEARCH: string = "ahorros-search";
    public static PATH_AHORROS_FORM: string = "ahorros-form";
    public static FULLPATH_AHORROS_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_AHORROS + "/" + PathConstants.PATH_AHORROS_SEARCH;
    public static FULLPATH_AHORROS_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_AHORROS + "/" + PathConstants.PATH_AHORROS_FORM;

    public static PATH_DATOS: string = "datos";
    public static PATH_DATOS_SEARCH: string = "datos-search";
    public static PATH_DATOS_FORM: string = "datos-form";
    public static FULLPATH_DATOS_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_DATOS + "/" + PathConstants.PATH_DATOS_SEARCH;
    public static FULLPATH_DATOS_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_DATOS + "/" + PathConstants.PATH_DATOS_FORM;


    public static PATH_BANNERES: string = "banneres";
    public static PATH_BANNERES_SEARCH: string = "banneres-search";
    public static PATH_BANNERES_FORM: string = "banneres-form";
    public static FULLPATH_BANNERES_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_BANNERES + "/" + PathConstants.PATH_BANNERES_SEARCH;
    public static FULLPATH_BANNERES_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_BANNERES + "/" + PathConstants.PATH_BANNERES_FORM;

    public static PATH_CALENDARIOS: string = "calendarios";
    public static PATH_CALENDARIOS_SEARCH: string = "calendarios-search";
    public static PATH_CALENDARIOS_FORM: string = "calendarios-form";
    public static FULLPATH_CALENDARIOS_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_CALENDARIOS + "/" + PathConstants.PATH_CALENDARIOS_SEARCH;
    public static FULLPATH_CALENDARIOS_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_CALENDARIOS + "/" + PathConstants.PATH_CALENDARIOS_FORM;

    public static PATH_CREDITOS: string = "creditos";
    public static PATH_CREDITOS_SEARCH: string = "creditos-search";
    public static PATH_CREDITOS_FORM: string = "creditos-form";
    public static FULLPATH_CREDITOS_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_CREDITOS + "/" + PathConstants.PATH_CREDITOS_SEARCH;
    public static FULLPATH_CREDITOS_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_CREDITOS + "/" + PathConstants.PATH_CREDITOS_FORM;

    public static PATH_EMPRESASES: string = "empresases";
    public static PATH_EMPRESASES_SEARCH: string = "empresases-search";
    public static PATH_EMPRESASES_FORM: string = "empresases-form";
    public static FULLPATH_EMPRESASES_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_EMPRESASES + "/" + PathConstants.PATH_EMPRESASES_SEARCH;
    public static FULLPATH_EMPRESASES_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_EMPRESASES + "/" + PathConstants.PATH_EMPRESASES_FORM;

    public static PATH_EVENTOS: string = "eventos";
    public static PATH_EVENTOS_SEARCH: string = "eventos-search";
    public static PATH_EVENTOS_FORM: string = "eventos-form";
    public static FULLPATH_EVENTOS_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_EVENTOS + "/" + PathConstants.PATH_EVENTOS_SEARCH;
    public static FULLPATH_EVENTOS_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_EVENTOS + "/" + PathConstants.PATH_EVENTOS_FORM;

    public static PATH_DOCUMENTOS: string = "documentos";
    public static PATH_DOCUMENTOS_SEARCH: string = "documentos-search";
    public static PATH_DOCUMENTOS_FORM: string = "documentos-form";
    public static FULLPATH_DOCUMENTOS_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_DOCUMENTOS + "/" + PathConstants.PATH_DOCUMENTOS_SEARCH;
    public static FULLPATH_DOCUMENTOS_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_DOCUMENTOS + "/" + PathConstants.PATH_DOCUMENTOS_FORM;


    public static PATH_FOTOS: string = "fotos";
    public static PATH_FOTOS_SEARCH: string = "fotos-search";
    public static PATH_FOTOS_FORM: string = "fotos-form";
    public static FULLPATH_FOTOS_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_FOTOS + "/" + PathConstants.PATH_FOTOS_SEARCH;
    public static FULLPATH_FOTOS_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_FOTOS + "/" + PathConstants.PATH_FOTOS_FORM;

    public static PATH_MEDICOS: string = "medicos";
    public static PATH_MEDICOS_SEARCH: string = "medicos-search";
    public static PATH_MEDICOS_FORM: string = "medicos-form";
    public static FULLPATH_MEDICOS_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_MEDICOS + "/" + PathConstants.PATH_MEDICOS_SEARCH;
    public static FULLPATH_MEDICOS_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_MEDICOS + "/" + PathConstants.PATH_MEDICOS_FORM;

    public static PATH_NOTICIAS: string = "noticias";
    public static PATH_NOTICIAS_SEARCH: string = "noticias-search";
    public static PATH_NOTICIAS_FORM: string = "noticias-form";
    public static FULLPATH_NOTICIAS_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_NOTICIAS + "/" + PathConstants.PATH_NOTICIAS_SEARCH;
    public static FULLPATH_NOTICIAS_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_NOTICIAS + "/" + PathConstants.PATH_NOTICIAS_FORM;


    public static PATH_BIENESTARES: string = "bienestares";
    public static PATH_BIENESTARES_SEARCH: string = "bienestares-search";
    public static PATH_BIENESTARES_FORM: string = "bienestares-form";
    public static FULLPATH_BIENESTARES_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_BIENESTARES + "/" + PathConstants.PATH_BIENESTARES_SEARCH;
    public static FULLPATH_BIENESTARES_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_BIENESTARES + "/" + PathConstants.PATH_BIENESTARES_FORM;


    public static PATH_PARTICIPANTES: string = "participantes";
    public static PATH_PARTICIPANTES_SEARCH: string = "participantes-search";
    public static PATH_PARTICIPANTES_FORM: string = "participantes-form";
    public static FULLPATH_PARTICIPANTES_SEARCH: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_PARTICIPANTES + "/" + PathConstants.PATH_PARTICIPANTES_SEARCH;
    public static FULLPATH_PARTICIPANTES_FORM: string = PathConstants.PATH_ADMIN + "/" + PathConstants.PATH_PARTICIPANTES + "/" + PathConstants.PATH_PARTICIPANTES_FORM;



    public static PATH_PAG_NOTICIA:string = "noticia";
    public static PATH_PAG_HISTORIA:string = "historia";
    public static PATH_PAG_MISION:string = "mision";
    public static PATH_PAG_VISION:string = "vision";
    public static PATH_PAG_MASCOTA:string = "mascota";
    
    public static PATH_PAG_ESTRUCTURA:string = "estructura";
    public static PATH_PAG_NORMATIVA:string = "normativa";
    public static PATH_PAG_VALORES:string = "valores";
    public static PATH_PAG_AHORRO:string = "ahorro";
    public static PATH_PAG_SIMULADOR_AHORRO:string = "simuladorahorro";
    public static PATH_PAG_HIMNO:string = "himno";
    public static PATH_PAG_CREDITO:string = "credito";
    public static PATH_PAG_SIMULADOR_CREDITO:string = "simuladorcredito"
    public static PATH_PAG_MEDICOS:string = "medicos";
    public static PATH_PAG_EMPRESAS:string = "empresas";
    public static PATH_PAG_PROGRAMACION:string = "programacion";
    public static PATH_PAG_EVENTOS:string = "eventos";
    public static PATH_PAG_INFORME:string = "informes";
    public static PATH_PAG_PLATAFORMA:string = "plataforma";
    public static PATH_PAG_BIENESTAR:string = "bienestar";
    public static PATH_PAG_ACTAS:string = "actas";
    public static PATH_PAG_PASO_UNO:string = "pasouno";
    public static PATH_PAG_PASO_DOS:string = "pasodos";
    
    
    
    
    
}



// WEBPACK FOOTER //
// ./src/app/util/path.constants.ts